import React from 'react'
import {connect} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {SearchResult} from 'jbc-front/components/SearchForm'
import {selector} from 'documents/create/list/utils'

const mapStateToProps = (state, {pathname}) => ({
  pathname,
  total: state.employees.list.count,
  page: selector(state, 'page'),
  isLoading: state.employees.list.loading,
  failureMessage: '従業員が見つかりませんでした',
})

const ConnectedSearchResult = connect(mapStateToProps)(SearchResult)

const SearchResultContainer = (props) => {
  const {pathname} = useLocation()
  return <ConnectedSearchResult {...props} pathname={pathname} />
}

export default SearchResultContainer
